import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { GetAllVisibleNodesAsync } from "motw_core/Workflows/GetVisibleNodes";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IWorkflowsState } from "source/app/presentation/MainPanel/Workflows/IWorkflowsState";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";
import { DeleteMultipleNodesAsync } from "./ChangeData/DeleteNodesAsync";

function GetWorkflows() {
    return State.ReadClass<IWorkflowsState>(ESharedComponent.Workflows);
}

export function IsWorkflowMultiSelectEnabled() {
    const workflows = GetWorkflows();

    return workflows?.state.isMultiSelectMode ?? false;
}

export function GetSelectedWorkflowNodes() {
    const workflows = GetWorkflows();

    if (!workflows) {
        return [];
    }

    const selectedNodeIds = new Set(workflows.state.selectedNodeIds);

    return workflows.state.visibleNodes.filter((node) =>
        selectedNodeIds.has(node.id)
    );
}

export async function GetSelectedWorkflowNodesToDeleteAsync() {
    const selectedNodes = GetSelectedWorkflowNodes();

    if (selectedNodes.length === 0) {
        return [];
    }

    const visibleNodeSets = await Promise.all(
        selectedNodes.map((node) => GetAllVisibleNodesAsync(node))
    );

    const nodesById = new Map<number, IWorkflowNode>();

    visibleNodeSets
        .flat()
        .filter((node): node is IWorkflowNode => node !== undefined)
        .forEach((node) => {
        nodesById.set(node.id, node);
    });

    return [...nodesById.values()];
}

export function ToggleWorkflowMultiSelectMode() {
    const workflows = GetWorkflows();

    if (!workflows) {
        return;
    }

    const isMultiSelectMode = !workflows.state.isMultiSelectMode;

    workflows.setState({
        isMultiSelectMode,
        selectedNodeIds: isMultiSelectMode ? workflows.state.selectedNodeIds : [],
    });
}

export function ToggleWorkflowNodeSelection(node: IWorkflowNode) {
    const workflows = GetWorkflows();

    if (!workflows || !workflows.state.isMultiSelectMode) {
        return;
    }

    const selectedNodeIds = [...workflows.state.selectedNodeIds];
    const selectedIndex = selectedNodeIds.indexOf(node.id);

    if (selectedIndex >= 0) {
        selectedNodeIds.splice(selectedIndex, 1);
    } else {
        selectedNodeIds.push(node.id);
    }

    workflows.setState({ selectedNodeIds });
}

export async function DeleteSelectedWorkflowNodesAsync() {
    const workflows = GetWorkflows();

    if (!workflows) {
        return;
    }

    const selectedNodesPromise = GetSelectedWorkflowNodesToDeleteAsync();

    workflows.setState({
        isMultiSelectMode: false,
        selectedNodeIds: [],
    });

    const selectedNodes = await selectedNodesPromise;

    if (selectedNodes.length === 0) {
        return;
    }

    await DeleteMultipleNodesAsync(selectedNodes);
}

export function GetSelectedWorkflowNodeCount() {
    const workflows = GetWorkflowsState();

    return workflows?.state.selectedNodeIds.length ?? 0;
}
